// funding app
export const FUNDING_APP_BASE_URL = () => {
  return process.env.REACT_APP_FUNDING_APP_MERCHANT_BASE_URL;
};

// underwriting app
export const UNDERWRITING_BASE_URL = () => {
  return process.env.REACT_APP_UNDERWRITING_BASE_URL;
};

export const MIXPANEL_API_TOKEN = () => {
  return process.env.REACT_APP_MIXPANEL_API_MERCHANT_TOKEN;
};

export const DATADOG_RUM_APPLICATION_ID = () => {
  return process.env.REACT_APP_DATADOG_RUM_APPLICATION_ID;
};

export const DATADOG_RUM_CLIENT_TOKEN = () => {
  return process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN;
};

export const DATADOG_SITE = () => {
  return process.env.REACT_APP_DATADOG_SITE;
};

export const DEPLOY_ENV = () => {
  return process.env.REACT_APP_DEPLOY_ENV;
};

export const APP_VERSION = () => {
  return process.env.REACT_APP_VERSION;
};
